export default "__VITE_ASSET__BNcLM0YX__"